<template>
  <div>
    <v-divider />
    <v-container>
      <!-- 分类导航 -->
      <v-row v-if="!showDetail" class="mb-4 category-nav">
        <v-col cols="12">
          <v-chip-group v-model="selectedCategory" mandatory>
            <v-chip
              v-for="cat in categories"
              :key="cat.id"
              :value="cat.id"
              filter
              outlined
              :color="selectedCategory === cat.id ? 'primary' : ''"
            >
              {{ cat.name }}
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <!-- 文章列表 -->
      <v-row v-if="!showDetail">
        <v-col
          v-for="(item, index) in filteredLists"
          :key="item.help_center_id"
          cols="12"
          md="6"
          lg="4"
          class="pa-4"
        >
          <v-card
            class="article-card whitebg cursor-pointer h-100"
            @click="viewDetail(item)"
          >
            <div v-if="index < 3 && (selectedCategory === '3' || selectedCategory === '8')" class="featured-badge">
              {{ lang === 'en' ? 'Must Read' : '入站必看' }}
            </div>
            <v-img
              :src="item.imgs"
              height="220"
              width="100%"
              cover
            ></v-img>
            <v-card-text class="pt-2">
              <div class="text-h6 font-weight-bold mb-2 article-title">
                {{ item.title }}
              </div>
              <div class="text-body-2 grey--text text--darken-1 article-abstract">
                {{ item.abstract }}
              </div>
              <div class="text-caption grey--text mt-2">
                {{ item.createtime }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- 详情页 -->
      <div v-else>
        <v-btn text color="primary" class="mb-4" @click="backToList">
          <v-icon left>mdi-arrow-left</v-icon>
          {{ $t("返回") }}
        </v-btn>
        <div class="pa-8">
          <h1 class="text-h4 font-weight-bold mb-4">{{ detailData.title }}</h1>
          <div v-html="detailData.content"></div>
        </div>
      </div>
    </v-container>

    <!-- 回到顶部按钮 -->
    <v-btn
      v-show="showBackToTop"
      color="primary"
      dark
      fixed
      bottom
      right
      large
      class="mb-16 back-to-top"
      @click="scrollToTop"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lists: [],
      filteredLists: [],
      selectedItem: "0",
      selectedCategory: "",
      categories: [],
      showBackToTop: false,
      showDetail: false,
      detailData: {},
      lang: localStorage.getItem("langdef") || "en"
    };
  },
  created() {
    this.initCategories();
  },
  mounted() {
    this.getlist();
    this.updateSeoMeta();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    selectedCategory(newVal) {
      this.filterLists();
      this.updateSeoMeta();
    }
  },
  methods: {
    updateSeoMeta() {
      const lang = localStorage.getItem("langdef") || "en";
      const titles = {
        en: {
          "8": "Setup Guides - Taoify Help Center",
          "9": "Operation Tips - Taoify Help Center",
          "10": "Feature Breakdowns - Taoify Help Center",
          "11": "Industry Comparisons - Taoify Help Center",
          "12": "Customer Case Studies - Taoify Help Center"
        },
        zh: {
          "3": "建站教程 - Taoify帮助中心",
          "5": "功能详解 - Taoify帮助中心",
          "4": "运营干货 - Taoify帮助中心",
          "6": "行业对比 - Taoify帮助中心",
          "7": "客户案例 - Taoify帮助中心"
        }
      };
      const desc = {
        en: "Expert guides on overseas sourcing, logistics, and international trade. Stay informed with the latest industry insights.",
        zh: "跨境电商建站教程、功能详解、运营干货、行业对比和客户案例，帮助您在跨境电商领域取得成功。"
      };
      const keywords = {
        en: "Taoify, cross-border e-commerce, setup guides, operation tips, feature breakdowns, industry comparisons, customer cases",
        zh: "跨境电商,建站教程,功能详解,运营干货,行业对比,客户案例,独立站,在线商店"
      };

      const catName = titles[lang][this.selectedCategory] || titles[lang]["8"];
      const descContent = desc[lang];
      const kwContent = keywords[lang];

      document.querySelector("meta[name='keywords']").setAttribute("content", kwContent);
      document.querySelector("meta[name='description']").setAttribute("content", descContent);
      document.title = catName;
    },
    updateDetailSeo(title, abstract) {
      const titleText = title + " - Taoify Help Center";
      document.querySelector("meta[name='description']").setAttribute("content", abstract);
      document.title = titleText;
    },
    handleScroll() {
      const scrollTop = window.scrollY || window.pageYOffset;
      this.showBackToTop = scrollTop > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    decodeHtmlEntities(str) {
      if (!str) return "";
      const textarea = document.createElement("textarea");
      textarea.innerHTML = str;
      return textarea.value;
    },
    initCategories() {
      const lang = localStorage.getItem("langdef") || "en";
      if (lang === "en") {
        this.categories = [
          { id: "8", name: "Setup Guides" },
          { id: "9", name: "Operation Tips" },
          { id: "10", name: "Feature Breakdowns" },
          { id: "11", name: "Industry Comparisons" },
          { id: "12", name: "Customer Case Studies" }
        ];
        this.selectedCategory = "8";
      } else {
        this.categories = [
          { id: "3", name: "建站教程" },
          { id: "5", name: "功能详解" },
          { id: "4", name: "运营干货" },
          { id: "6", name: "行业对比" },
          { id: "7", name: "客户案例" }
        ];
        this.selectedCategory = "3";
      }
    },
    filterLists() {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (this.selectedCategory) {
        this.filteredLists = this.lists.filter(
          item => item.type_id == this.selectedCategory
        );
      }
    },
    getlist() {
      this.$api.help.get_help_list().then(res => {
        if (res.status == 1) {
          this.lists = res.data.records;
          this.filterLists();
        }
      });
    },
    viewDetail(item) {
      this.$api.help
        .get_help_detail({ help_center_id: item.help_center_id })
        .then(res => {
          if (res.status == 1) {
            this.detailData = {
              title: item.title,
              content: this.decodeHtmlEntities(res.data.content),
              abstract: item.abstract
            };
            this.showDetail = true;
            this.updateDetailSeo(item.title, item.abstract);
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
    },
    backToList() {
      this.showDetail = false;
      this.detailData = {};
      this.updateSeoMeta();
    }
  }
};
</script>
<style scoped>
.category-nav {
  position: sticky;
  top: 50px;
  z-index: 2;
  background: #fff;
  padding-top: 16px;
}
.article-card {
  height: 100%;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
}
.whitebg {
  background: #fff;
}
.article-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}
.article-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
.article-abstract {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
img {
  max-width: 100%;
}
.back-to-top {
  z-index: 1000;
}
.cursor-pointer {
  cursor: pointer;
}
.featured-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  background: linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%);
  color: #fff;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  z-index: 1;
  box-shadow: 0 4px 12px rgba(255, 107, 53, 0.4);
}
</style>